import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { makeStyles, Typography, Button } from '@material-ui/core';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import MovieCardSimple from '../MovieCardSimple/MovieCardSimple';
import styles from './styles';
import MovieBanner from '../MovieBanner/MovieBanner';
import { useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles(styles);

function NextArrow(props) {
  const { currentSlide, slideCount, onClick } = props;
  const classes = useStyles({ currentSlide, slideCount });
  return (
    <div className={classnames(classes.HeaderArrow, 'nextArrow')} onClick={onClick}>
      <ArrowForwardIos color="inherit" fontSize="large" />
    </div>
  );
}

function PrevArrow(props) {
  const { currentSlide, onClick } = props;
  const classes = useStyles({ currentSlide });
  return (
    <div className={classnames(classes.HeaderArrow, 'prevArrow')} onClick={onClick}>
      <ArrowBackIos color="inherit" fontSize="large" />
    </div>
  );
}

function MovieHeaderCarousel({ carouselClass, movies = [], title, to = null }) {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:600px)');
    const settings = {
        // classNames: "center",
        centerPadding: isMobile?"0px" : "60px",
    centerMode: true,
    infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
    slidesToShow: 1,
    swipeToSlide: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    // responsive: [
    //   {
    //     breakpoint: 1600,
    //     settings: {
    //       slidesToShow: 3
    //     }
    //   },
    //   {
    //     breakpoint: 1250,
    //     settings: {
    //       slidesToShow: 2
    //     }
    //   },
    //   {
    //     breakpoint: 750,
    //     settings: {
    //       slidesToShow: 1
    //     }
    //   }
    // ]
  };
  if (!movies.length) return null;
  return (
    <div className={carouselClass}>
      <div className={classes.container}>
        <Typography className={classes.h2} variant="h2" color="inherit">
          {title}
        </Typography>
        {to==null? null
           :
          <Link to={to} style={{ textDecoration: 'none' }}>
          <Button className={classes.button} color="primary">
            Explore All
          </Button>
        </Link>
      }
      </div>
      <Slider {...settings} >
        {movies.map(movie => (
          // <MovieCardSimple key={movie._id} movie={movie} />
         <MovieBanner movie={movie} height={isMobile ? "40vh" : "70vh"}/> 

        ))}
      </Slider>
    </div>
  );
}
export default MovieHeaderCarousel;
